import $ from "jquery";
import gsap from "gsap";
import Swiper from "swiper";

import {
  Mousewheel,
  Pagination,
  Navigation,
  EffectFade,
  EffectCreative,
  Autoplay,
} from "swiper/modules";

export default class TestimonialCarousel {
  $el = $("section.testimonial-carousel");
  carousel = null;
  type = "cards"; // Is either 'cards' or 'amplify'.

  constructor() {
    if (!this.$el.length) return;

    this.init();
  }

  init() {
    this.type = this.$el.data("type");

    Swiper.use([
      Mousewheel,
      EffectFade,
      EffectCreative,
      Pagination,
      Navigation,
      Autoplay,
    ]);

    this.pickCarouselType();

    window.onresize = () => {
      this.pickCarouselType();
    };
  }

  pickCarouselType() {
    if (this.type === "amplify") {
      if (window.innerWidth >= 768) {
        this.setupAmplifyCarousel();
      } else {
        this.setupCardsCarousel();
      }
    } else {
      this.setupCardsCarousel();
    }
  }

  setupAmplifyCarousel() {
    const pagination = this.$el.find(".swiper-pagination").get(0);

    this.carousel = new Swiper(this.$el.find(".swiper").get(0), {
      slidesPerView: 1,
      spaceBetween: 50,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: pagination,
        clickable: true,
        // Classes.
        bulletClass:
          "w-4 h-4 inline-block border border-white rounded-full ml-2",
        bulletActiveClass: "bg-white",
      },
      mousewheel: {
        releaseOnEdges: true,
        forceToAxis: true,
      },
    });
  }

  setupCardsCarousel() {
    const style = this.$el.find(".style-cards");

    const carousel = style.find(".swiper").get(0);
    const numSlides = style.find(".swiper-slide").length;
    const prev = style.find(".card-swiper-prev").get(0);
    const next = style.find(".card-swiper-next").get(0);

    this.carousel = new Swiper(carousel, {
      effect: "creative",
      navigation: {
        nextEl: next,
        prevEl: prev,
      },

      creativeEffect: {
        progressMultiplier: 1,
        limitProgress: 1.5,
        prev: {
          scale: 0.8,
          translate: [-135, 0, 0],
        },
        next: {
          scale: 0.8,
          translate: [135, 0, 0],
        },
      },
      initialSlide: numSlides / 2,
      loop: false,
      centeredSlides: true,
      centeredMode: true,
      preventInteractionOnTransition: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      speed: 500,
      followFinger: false,
      mousewheel: {
        releaseOnEdges: true,
        forceToAxis: true,
      },
      on: {
        init: (swiper) => {
          this.cardCarouselAnimation(swiper.activeIndex);
          $(carousel).removeClass("scale-0");
        },
        transitionStart: (swiper) => {
          this.cardCarouselAnimation(swiper.activeIndex);
        },
      },

      breakpoints: {
        1024: {
          creativeEffect: {
            progressMultiplier: 0.9,
            limitProgress: 3,
            prev: {
              scale: 0.8,
              translate: [-145, 0, 0],
            },
            next: {
              scale: 0.8,
              translate: [145, 0, 0],
            },
          },
        },
        1280: {
          creativeEffect: {
            progressMultiplier: 0.9,
            limitProgress: 3,
            prev: {
              scale: 0.8,
              translate: [-185, 0, 0],
            },
            next: {
              scale: 0.8,
              translate: [185, 0, 0],
            },
          },
        },
      },
    });
  }

  cardCarouselAnimation(activeSlide) {
    // Round activeSlide down to the nearest whole number.
    activeSlide = Math.floor(activeSlide);

    const style = this.$el.find(".style-cards");

    const $activeSlide = style.find(".swiper-slide")[activeSlide];

    // Get slides after active slide.
    const $nextSlides = $($activeSlide).nextAll();

    // Get slides before active slide.
    const $prevSlides = $($activeSlide).prevAll();

    const $svg = $($activeSlide).find("svg path").get(0);

    if (window.innerWidth > 1023) {
      // Transform the active slide.
      gsap.to($svg, {
        duration: 0,
        attr: {
          d: "M389.068, 370.285, 0, 411.78, 18.835, 0 l538.12,50.427 L572, 350.776 l-97.476, 10.4-85.455, 85.789Z",
        },
        ease: "power2.inOut",
      });

      // Transform the next slides by mirroring the SVG.
      $nextSlides.each((index, slide) => {
        const $svg = $(slide).find("svg path").get(0);

        gsap.to($svg, {
          duration: 0.2,
          attr: {
            d: " M0, 370.285, 0, 411.78, 118.835, -100 l538.12,50.427 L572, 400",
          },
          ease: "power2.inOut",
        });

        gsap.to($svg, {
          duration: 0,
        });
      });

      // Transform the previous slides by mirroring the SVG.
      $prevSlides.each((index, slide) => {
        const $svg = $(slide).find("svg path").get(0);

        gsap.to($svg, {
          duration: 0.2,
          attr: {
            d: " M389.068, 370.285, 0, 411.78, 18.835, 0 l538.12,50.427 L572, 350.776",
          },
          ease: "power2.inOut",
        });
      });
    } else {
      // On mobile devices, add the "tick" to all slides.
      gsap.to(this.$el.find(".style-cards .swiper-slide svg path"), {
        duration: 0,
        attr: {
          d: "M389.068, 370.285, 0, 411.78, 18.835, 0 l538.12,50.427 L572, 350.776 l-97.476, 10.4-85.455, 85.789Z",
        },
        ease: "power2.inOut",
      });
    }
  }
}
